import { render, staticRenderFns } from "./RevenueTax.vue?vue&type=template&id=5b9f3439&scoped=true"
import script from "./RevenueTax.vue?vue&type=script&lang=js"
export * from "./RevenueTax.vue?vue&type=script&lang=js"
import style0 from "./RevenueTax.vue?vue&type=style&index=0&id=5b9f3439&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9f3439",
  null
  
)

export default component.exports